import ChangePasswordPage from "./ChangePasswordPage";

export {
    ChangePasswordPage
}